import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id')({
  beforeLoad: () => getTitleContextSlice('Edit Report'),
  staticData: {
    owner: CodeOwner.Analytics,
  },
});
